<template>
  <div id="app">
    <nav-bar />
    <div id="nav"></div>
    <b-container fluid class="p-3">
      <!-- $route.fullPath stops vue from using components if they
      are also present in the destination view-->
      <router-view :key="$route.fullPath" />
    </b-container>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
export default {
  components: { "nav-bar": NavBar }
};
</script>

<style lang="scss">
</style>
